@if (accountService.subscriptionExpired) {
  <app-banner variant="warning">
    <b>Your {{ uiService.productName }} subscription has expired.</b> You can still review and modify your account, but
    recovery points are not currently being captured and you are not able to execute tests or recoveries.
    <a banner-action [routerLink]="uiService.buildSubscriptionSettingsUrl(accountService.accountId)">
      Renew subscription <svg lucideChevronRight></svg>
    </a>
  </app-banner>
}

<!-- This shows a banner if there is an AWS outage -->
@if (awsOutageObj$ | async; as awsOutageObj) {
  @if (awsOutageObj?.visible == true) {
    <app-banner variant="info">
      <span [innerHtml]="awsOutageObj?.safeHtml"></span>
    </app-banner>
  }
}

<account-navigation [account-id]="accountId" [initialized]="initialized">
  <!-- Account capacity banner: warning at 100%, critical above 105% of contracted billable resources. -->
  @if (capacityBanner; as capacity) {
    <app-banner
      [variant]="capacity.variant"
      [dismissible]="true"
      (dismissed)="dismissCapacityBanner(capacity.threshold)"
    >
      <b>{{ capacity.lead }}</b> {{ capacity.detail }}
    </app-banner>
  }
</account-navigation>
